import React from 'react'

export const AccountBalance = (color = '#1973B8', width = 28, height = 27) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66602 21.6663V12.333H7.33268V21.6663H4.66602ZM12.666 21.6663V12.333H15.3327V21.6663H12.666ZM0.666016 26.9997V24.333H27.3327V26.9997H0.666016ZM20.666 21.6663V12.333H23.3327V21.6663H20.666ZM0.666016 9.66634V6.99967L13.9993 0.333008L27.3327 6.99967V9.66634H0.666016ZM6.59935 6.99967H21.3993L13.9993 3.33301L6.59935 6.99967Z"
        fill={color}
      />
    </svg>
  )
}
